module.exports = "<div>\n  <h1 class=\"heading\">\n    <span class=\"fa fa-info bg-icon-yellow\"></span>{{headerTitle}}\n  </h1>\n</div>"